module.exports = __webpack_public_path__ + "img/bneo-icon.68237737.svg";